import { z } from 'zod';
import { getVatIdPattern } from './vat-id.patterns';


export const vatIdSchema = z
    .string()
    .trim()
    .toUpperCase()
    .refine((value) => {
        return getVatIdPattern(value).test(value);
    }, {
        message: 'Enter a valid VAT ID',
    });

export const optionalVatIdSchema = z
    .string()
    .trim()
    .toUpperCase()
    .refine((value) => {
        if (!value) {
            return true;
        }

        return getVatIdPattern(value).test(value);
    }, {
        message: 'Enter a valid VAT ID',
    })
    .optional();
